import { useEffect, useState } from "react";
import { X, TriangleAlert } from "lucide-react";

export default function CentralStatusBanner() {
  const [offline, setOffline] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let active = true;
    const check = () => {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/central-status`)
        .then((r) => r.json())
        .then((data) => {
          if (active) setOffline(data.online === false);
        })
        .catch(() => {});
    };
    check();
    const id = setInterval(check, 300000);
    return () => {
      active = false;
      clearInterval(id);
    };
  }, []);

  if (!offline || dismissed) return null;

  return (
    <div
      data-testid="central-status-banner"
      className="fixed inset-x-0 top-20 z-30 bg-amber-400 text-black"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-5 py-3 text-sm font-medium sm:px-8">
        <TriangleAlert className="h-4 w-4 shrink-0" />
        <p>
          A Central do Assinante está temporariamente fora do ar. Fale com a
          gente pelo WhatsApp: (13) 99731-2739.
        </p>
        <button
          data-testid="central-status-dismiss"
          onClick={() => setDismissed(true)}
          aria-label="Fechar aviso"
          className="absolute right-4 rounded p-1 transition-colors duration-200 hover:bg-black/10"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
